<template>
  <div class="demo_loop">
    <div class="player_centre">
      <div class="player_responsive">
        <uep-player
          class="player"
          v-show="loaded"
          :standalone="standalone"
          :query="query"
          @readyPlayer="readyPlayer"
        ></uep-player>
      </div>
    </div>
  </div>
</template>
<script>
import { LOOP_OPTIONS } from "../../store/video/loop";
export default {
  data() {
    return {
      loaded: false,
      query: { plugin: "simple", skin: "15" },
      standalone: LOOP_OPTIONS,
    };
  },
  methods: {
    readyPlayer(param) {
      var player = param;
      player.cryptedParam = this.crypttext;
      this.loaded = true;
    },
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 736px) {
  .demo_loop {
    .player_centre {
      .player_responsive {
        width: 100%!important;
        height: 56.25vw!important;
      }
    }
  }
}
.demo_loop {
  .player_centre {
    display: flex;
    justify-content: center;
    margin-top: 1em;
    .player_responsive {
      position: relative;
      padding-top: 0;
      overflow: hidden;
      width: 60vw;
      height: 33.75vw;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      .player {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Loop.vue?6b2dff64